import { useCallback } from 'react';
import {
  ControllerFieldState,
  ControllerRenderProps,
  FieldPath,
  FieldValues,
} from 'react-hook-form';

import { ListValue } from '@xemplo/stateful-list-core';

import { TextDropdownMultiRhfProps } from '../text-dropdown-multi.types';

export type FieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = {
  field: ControllerRenderProps<TFieldValues, TName>;
  fieldState: ControllerFieldState;
};

type UseTextDropdownMultiRhfProps = TextDropdownMultiRhfProps & {
  fieldProps: FieldProps;
};

export function useTextDropdownMultiRhf(props: UseTextDropdownMultiRhfProps) {
  const { field, fieldState } = props.fieldProps;
  const { onChange, onSearchChange } = props;
  const fieldOnChange = field.onChange;

  const handleChange = useCallback(
    (value: ListValue[]) => {
      fieldOnChange(value);
      onChange?.(value);
    },
    [fieldOnChange, onChange]
  );

  return {
    ...props,
    errorMessage: fieldState.error?.message,
    onChange: handleChange,
    onSearchChange,
    value: field.value,
  };
}
